import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CargoPackageVisual, CargoPanda } from './CargoVisuals';

const contentByKind = {
  v4_green: {
    tag: '🎨 YENİ RENK AÇILDI',
    title: 'Yeşil kargolar geldi!',
    description: 'Mavi ve sarı kargolar devam ediyor. Artık yeşilleri de birlikte ayıracağız!',
    button: 'Üç renkle başlayalım! →',
    items: [
      { color: 'blue', packageType: 'box', label: 'MAVİ', caption: 'Bildiklerimiz' },
      { color: 'green', packageType: 'envelope', label: 'YEŞİL', caption: 'Yeni renk' },
    ],
  },
  v4_orange: {
    tag: '🎨 YENİ RENK AÇILDI',
    title: 'Turuncu kargolar geldi!',
    description: 'Mavi, sarı ve yeşilin yanına turuncu da katıldı. Dört renk birlikte!',
    button: 'Dört renkle başlayalım! →',
    items: [
      { color: 'green', packageType: 'box', label: 'YEŞİL', caption: 'Bildiklerimiz' },
      { color: 'orange', packageType: 'envelope', label: 'TURUNCU', caption: 'Yeni renk' },
    ],
  },
  v4_purple: {
    tag: '🎨 YENİ RENK AÇILDI',
    title: 'Mor kargolar geldi!',
    description: 'Mavi, sarı, yeşil ve turuncuya mor da katıldı. Artık beş rengi birlikte ayırıyoruz!',
    button: 'Beş renkle başlayalım! →',
    items: [
      { color: 'green', packageType: 'box', label: 'YEŞİL', caption: 'Bildiklerimiz' },
      { color: 'purple', packageType: 'envelope', label: 'MOR', caption: 'Yeni renk' },
    ],
  },
  v4_tube: {
    tag: '📦 YENİ KARGO TÜRÜ AÇILDI',
    title: 'Tüp kargolar geldi!',
    description: 'Kutu ve zarflar devam ediyor. Artık tüpleri de türüne göre ayırıyoruz!',
    button: 'Üç türle başlayalım! →',
    items: [
      { color: 'yellow', packageType: 'box', label: 'KUTU', caption: 'Bildiklerimiz' },
      { color: 'blue', packageType: 'tube', label: 'TÜP', caption: 'Yeni paket türü' },
    ],
  },
  v4_bag: {
    tag: '📦 YENİ KARGO TÜRÜ AÇILDI',
    title: 'Kargo poşetleri geldi!',
    description: 'Kutu, zarf ve tüplere poşet de katıldı. Dört paket türü artık birlikte!',
    button: 'Dört türle başlayalım! →',
    items: [
      { color: 'purple', packageType: 'tube', label: 'TÜP', caption: 'Bildiklerimiz' },
      { color: 'orange', packageType: 'bag', label: 'POŞET', caption: 'Yeni paket türü' },
    ],
  },
  colors: {
    tag: '🏆 YENİ BÖLÜM AÇILDI',
    title: 'Yeni renkler kargo merkezinde!',
    description: 'Mor ve turuncu paketler artık geliyor. Önce renkleri tanıyalım!',
    button: 'Harika, başlayalım! →',
    items: [
      { color: 'purple', packageType: 'box', label: 'MOR', caption: 'Yeni renk' },
      { color: 'orange', packageType: 'envelope', label: 'TURUNCU', caption: 'Yeni renk' },
    ],
  },
  objects: {
    tag: '📦 KARGO MERKEZİ BÜYÜYOR',
    title: 'Yeni paketler geldi!',
    description: 'Artık yalnızca kutu ve zarf yok. Tüp ve kargo poşetini de tanıyoruz!',
    button: 'Yeni paketleri tanı! →',
    items: [
      { color: 'blue', packageType: 'tube', label: 'TÜP', caption: 'Yeni paket türü' },
      { color: 'yellow', packageType: 'bag', label: 'POŞET', caption: 'Yeni paket türü' },
    ],
  },
};

export default function CargoUnlockOverlay({ kind, onContinue }) {
  const config = contentByKind[kind];
  if (!config) return null;
  return (
    <Box
      data-testid="cargo-unlock-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={config.title}
      sx={{
        position: 'absolute', inset: 0, zIndex: 20, display: 'flex', alignItems: 'center',
        justifyContent: 'center', px: { xs: 1.2, sm: 3 }, py: { xs: 2, sm: 3 },
        overflowY: 'auto', bgcolor: 'rgba(218,247,255,.88)',
        backgroundImage: 'radial-gradient(circle at 14% 16%, rgba(255,255,255,.9) 0 20px, transparent 21px), radial-gradient(circle at 85% 23%, rgba(255,255,255,.8) 0 24px, transparent 25px)',
      }}
    >
      <Box
        sx={{
          position: 'relative', bgcolor: '#FFFCFF', width: '100%', maxWidth: 650,
          border: '4px solid #fff', borderRadius: { xs: 4, sm: 7 },
          boxShadow: '0 9px 0 #6941AE, 0 18px 36px rgba(50,34,106,.16)',
          py: { xs: 2.1, sm: 3.2 }, px: { xs: 1.6, sm: 4 }, textAlign: 'center',
          '&:before': { content: '""', pointerEvents: 'none', position: 'absolute', inset: 9, borderRadius: { xs: 3, sm: 5 }, border: '2px dashed #E9DDFE' },
        }}
      >
        <Box sx={{ position: 'relative' }}>
          <Box sx={{ display: 'inline-flex', alignItems: 'center', px: 1.8, py: .7, borderRadius: 99, bgcolor: '#FFF0BC', border: '2px solid #FFDF77', color: '#875000', fontSize: { xs: 10, sm: 12 }, fontWeight: 1000, letterSpacing: '.04em' }}>
            {config.tag}
          </Box>
          <Typography component="h2" sx={{ mt: 1.5, color: '#4E258D', fontWeight: 1000, fontSize: { xs: 27, sm: 41 }, lineHeight: 1.05, letterSpacing: '-.045em' }}>
            {config.title}
          </Typography>
          <Typography sx={{ mt: 1, mx: 'auto', maxWidth: 450, color: '#755D92', fontSize: { xs: 13, sm: 16 }, fontWeight: 800, lineHeight: 1.35 }}>
            {config.description}
          </Typography>
          <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, justifyContent: 'center', my: { xs: 1.6, sm: 2.8 } }}>
            {config.items.map(({ color, packageType, label, caption }) => (
              <Box key={label} sx={{ width: { xs: 122, sm: 155 }, minWidth: 0, px: .8, pt: .6, pb: 1.1, border: '2px solid #E4DAF8', bgcolor: '#F8F5FF', borderRadius: 4, boxShadow: '0 5px 0 #E5DDF8' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: { xs: 77, sm: 105 } }}>
                  <Box sx={{ width: { xs: 77, sm: 94 }, height: { xs: 77, sm: 94 } }}>
                    <CargoPackageVisual color={color} packageType={packageType} size="100%" />
                  </Box>
                </Box>
                <Typography sx={{ color: '#503080', fontWeight: 1000, fontSize: { xs: 15, sm: 18 }, lineHeight: 1.2 }}>{label}</Typography>
                <Typography sx={{ color: '#876DA7', fontWeight: 850, fontSize: { xs: 10, sm: 11 }, mt: .5 }}>{caption}</Typography>
              </Box>
            ))}
          </Box>
          <Button
            data-testid="cargo-unlock-continue"
            variant="contained"
            onClick={onContinue}
            sx={{
              minHeight: 54, minWidth: { xs: 205, sm: 235 }, borderRadius: 99,
              bgcolor: '#7750E4', border: '3px solid #5D33BA', color: '#fff',
              fontWeight: 1000, fontSize: { xs: 16, sm: 18 }, textTransform: 'none',
              boxShadow: '0 6px 0 #492698, 0 12px 20px rgba(86,48,175,.2)',
              '&:hover': { bgcolor: '#6940D3' },
              '&:focus-visible': { outline: '4px solid #FFB728', outlineOffset: 4 },
            }}
          >
            {config.button}
          </Button>
        </Box>
        <Box sx={{ position: 'absolute', left: { xs: -6, sm: -35 }, top: { xs: -29, sm: 'auto' }, bottom: { xs: 'auto', sm: -33 }, pointerEvents: 'none', transform: 'rotate(-11deg)', width: { xs: 65, sm: 108 }, height: { xs: 65, sm: 108 } }}>
          <CargoPanda size="100%" />
        </Box>
      </Box>
    </Box>
  );
}
